<template>
  <div id="page-landing-region">
    <GlobalBreadcrumb
      v-if="!blok.removeBreadcrumb"
      :page-title="blok.overview_title"
    />
    <PageHeading
      :title="blok.overview_title"
      :subtitle="blok.overview_subtitle"
      narrow
    />
    <div
      v-for="(section, index) in blok.body"
      :key="section._uid"
      :class="`parent-bg background background-${section.component}${
        index % 2 !== 0 ? ' alternate' : ''
      }`"
    >
      <StoryblokComponent
        :blok="section"
        :content="context"
        :area="{ area_type: blok.area_type, area_value: blok.area_value }"
        :type="blok.facilityTypeGroupKey"
        class="section"
        tag="section"
      />
    </div>
  </div>
</template>

<script setup>
defineProps({
  blok: {
    type: Object,
    required: true,
  },
  context: {
    type: Object,
    required: false,
    default: () => ({}),
  },
});
</script>

<style lang="scss" scoped>
.background-list-with-title {
  @include pair-7;
}
#page-landing-region {
  :deep(.key-number) {
    @include pair-7;
  }
  :deep(.list-with-title) {
    .section-inner {
      @include pair-3;
    }
  }
  :deep(.facility-card) {
    @include pair-5;
  }
  :deep(.alternate .facility-card) {
    @include pair-7;
  }
}
</style>
